import * as _ from 'underscore';
import * as api from '../api';

export const apiCreate = async data => {
    if (data.tags.length > 0) {
        const tagIds = _.pluck(data.tags, 'id');
        delete data.tags;
        data.tagIds = tagIds;
    }
    if (data.swaps && data.swaps.length > 0) {
        data.swapExerciseIds = data.swaps.map(swap => swap.id);
    }
    delete data.swaps;
    return await api.post('/2.0/coach/exercise/create', data);
};

export const getAll = async (page, pageSize) => {
    let queryString = '';
    if (page) queryString = `?page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;

    return await api.get(`/1.0/coach/exercises${queryString}`);
};

export const getTags20 = async id =>
    await api.get(`/2.0/coach/exercise/getTags/${id}`);

export const getTrackers = async () => await api.get('/1.0/coach/trackers');

export const save = async (data, tags) => {
    data.tagIds = _.pluck(tags, 'id');
    return await api.post(`/2.0/coach/exercise/update/${data.id}`, data);
};

export const search = async q => await api.get(`/1.0/coach/exercises?q=${q}`);

export const searchByName = async q =>
    await api.get(`/1.0/coach/exercises?q=${q}`);
